// eslint-disable-next-line import/prefer-default-export
export const forbiddenInterceptor = (data) => {
  if (data.response.status === 401) {
    localStorage.removeItem('userInfo');
    window.location.replace('/login');
  }
};
